export default __webpack_public_path__ + "media/images/Masto-F1-Environnement-5c705e5562d0ca1be4e4edd2b99457bd.png";